// Copyright (c) 2025, Quantum Xchange, Inc
'use strict'

import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

export const useLoginMutation = (useMutationParams = {}) =>
    useMutation({
        mutationFn: async loginParams => await axios.post('/login', loginParams, { noNetworkFailure: true, noAuthFailure: true }),
        ...useMutationParams,
    })

export const useLogoutMutation = (useMutationParams = {}) =>
    useMutation({
        mutationFn: async () => await axios.post('/logout'),
        ...useMutationParams,
    })
